// window.location.hostname
import { WSS_URL } from '../apiService'

export const ENV_CONFIG = {
  debug_api: true,

  socketIO: {
    uri: WSS_URL,
    // uri: 'ws://127.0.0.1:37700',
    // path: '/socket.io/',
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    autoConnect: true,
    transports: ['websocket', 'polling'],
    rejectUnauthorized: true,
  },
}
